<div *ngIf="!workflow">
	<nz-page-header nzTitle="Loading workflow..."></nz-page-header>
</div>

<div class="p-4" *ngIf="workflow">
	<nz-page-header [nzTitle]="workflow.name"></nz-page-header>
	<nz-divider></nz-divider>

	<div *ngIf="!ticketReport.id || ticketReport.id < 0">
		<form nz-form [formGroup]="form">
			<nz-form-item>
				<nz-form-label [nzSpan]="4" nzFor="name">Report Name</nz-form-label>
				<nz-form-control [nzSpan]="8">
					<input nz-input formControlName="name" id="name" />
				</nz-form-control>
			</nz-form-item>

			<nz-form-item>
				<nz-form-label [nzSpan]="4" nzFor="description">Description</nz-form-label>
				<nz-form-control [nzSpan]="8">
					<textarea nz-input formControlName="description" id="description"></textarea>
				</nz-form-control>
			</nz-form-item>

			<nz-form-item>
				<nz-form-control [nzSpan]="8" [nzOffset]="4">
					<button nz-button nzType="primary" (click)="onCreate()">Create</button>
				</nz-form-control>
			</nz-form-item>
		</form>
	</div>


	<div *ngIf="ticketReport.id && ticketReport.id >= 0">
		<form nz-form [formGroup]="form">
			<div nz-row [nzGutter]="16">
				<div nz-col [nzSpan]="10">
					<nz-form-item>
						<nz-form-label [nzSpan]="6" nzFor="name">Report Name</nz-form-label>
						<nz-form-control [nzSpan]="14">
							<input nz-input formControlName="name" id="name" />
						</nz-form-control>
					</nz-form-item>

					<nz-form-item>
						<nz-form-label [nzSpan]="6" nzFor="description">Description</nz-form-label>
						<nz-form-control [nzSpan]="14">
							<textarea nz-input formControlName="description" id="description"></textarea>
						</nz-form-control>
					</nz-form-item>

					<nz-form-item>
						<nz-form-control [nzSpan]="8" [nzOffset]="4">
							<button nz-button nzType="primary" (click)="onSave()">Save</button>
						</nz-form-control>
					</nz-form-item>
				</div>
			</div>

			<nz-divider></nz-divider>

			<h3>Add Columns</h3>
			<div class="menu-container">
				<ul nz-menu nzMode="horizontal" nzTheme="light">
					<li *ngFor="let group of menu" nz-submenu [nzTitle]="group.label">
						<ul>
							<a *ngFor="let item of group.templates" nz-menu-item nzMatchRouter
								(click)="addColumn(item)">
								<span *ngIf="item.name.length > 0">
									<fa-icon [icon]="getMenuIcon(item)" size="xs"></fa-icon>
									{{item.name}}
								</span>
							</a>
							<li *ngFor="let subMenu of group.subMenus" nz-submenu [nzTitle]="subMenu.label">
								<ul>
									<a *ngFor="let item of subMenu.payload" nz-menu-item nzMatchRouter (click)="addColumn(item)">
										<span *ngIf="item.name.length > 0">
											<fa-icon [icon]="getMenuIcon(item)" size="xs"></fa-icon>
											{{item.name}}
										</span>
									</a>
								</ul>
							</li>
						</ul>
					</li>
				</ul>
			</div>

			<div class="row mt-5">
				<div class="col">Click on header to edit</div>
				<div class="col">
					<button class="float-end ms-2" nz-button nzType="primary" (click)="reloadPreview()">Refresh</button>
					<nz-form-item class="float-end">
						<nz-form-label nzFor="date">Date Filter</nz-form-label>
						<nz-form-control>
							<nz-date-picker formControlName="date"></nz-date-picker>
						</nz-form-control>
					</nz-form-item>
				</div>
			</div>


			<nz-table #table [nzData]="[1]" nzBordered [nzShowPagination]="false" [nzBordered]="true" [nzLoading]="loading">
				<thead>
					<tr cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="dropColumn($event)">
						<ng-container *ngFor="let column of ticketReport.columns">
							<th *ngIf="!column.parentId" cdkDrag (dblclick)="editColumn(column)" class="cursor-pointer draggable-header">
								<div class="header-content">
									<span class="drag-handle" cdkDragHandle>⋮⋮</span>
									<nz-icon *ngIf="column.filterOperator && column.filterValue" nzType="filter" nzTheme="outline" />
									<span>{{column.title}}</span>
								</div>
								<div class="drag-placeholder" *cdkDragPlaceholder></div>
							</th>
						</ng-container>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let row of previewData">
						<td *ngFor="let column of row.cells">{{column}}</td>
					</tr>
				</tbody>
			</nz-table>
		</form>
	</div>
</div>
